module.exports = __webpack_public_path__ + "static/media/WikaKita.32b23292.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/WikaKita.png
// module id = 35
// module chunks = 0